import { initializeApp, getApps, getApp, FirebaseApp } from 'firebase/app';
import { getStorage, FirebaseStorage, connectStorageEmulator } from 'firebase/storage';
import { getFirestore, Firestore, connectFirestoreEmulator } from 'firebase/firestore';

export const firebaseConfig = {
  apiKey: 'AIzaSyCaZbpErhQ7HBo-J6NBmrSn_ZE1owrpIts',
  authDomain: 'cognitiveintercept.firebaseapp.com',
  projectId: 'cognitiveintercept',
  storageBucket: 'cognitiveintercept.firebasestorage.app',
  messagingSenderId: '861174106073',
  appId: '1:861174106073:web:de060c3c17a5fddd9cbbc8',
};

let appInstance: FirebaseApp | null = null;
let storageInstance: FirebaseStorage | null = null;
let firestoreInstance: Firestore | null = null;

export function getFirebaseApp(): FirebaseApp {
  if (appInstance) return appInstance;
  if (getApps().length > 0) {
    appInstance = getApp();
  } else {
    appInstance = initializeApp(firebaseConfig);
  }
  return appInstance;
}

export function getFirebaseStorage(): FirebaseStorage {
  if (storageInstance) return storageInstance;
  const app = getFirebaseApp();
  storageInstance = getStorage(app);

  if (
    typeof window !== 'undefined' &&
    (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') &&
    (window as any).__USE_FIREBASE_EMULATORS__
  ) {
    try {
      connectStorageEmulator(storageInstance, '127.0.0.1', 9199);
    } catch {
      // Ignore if already connected
    }
  }

  return storageInstance;
}

export function getFirebaseFirestore(): Firestore {
  if (firestoreInstance) return firestoreInstance;
  const app = getFirebaseApp();
  firestoreInstance = getFirestore(app);

  if (
    typeof window !== 'undefined' &&
    (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') &&
    (window as any).__USE_FIREBASE_EMULATORS__
  ) {
    try {
      connectFirestoreEmulator(firestoreInstance, '127.0.0.1', 8080);
    } catch {
      // Ignore if already connected
    }
  }

  return firestoreInstance;
}
